import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class BookingActionModel extends Model {
  @attr('boolean') confirmPending!: boolean;

  @belongsTo('booking', { async: false, inverse: null })
  booking!: ModelRegistry['booking'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'booking-action': BookingActionModel;
  }
}
